import { Children, cloneElement, createElement } from 'react';
import styled from 'styled-components';
import { withToggleableOverlay } from '@optimus-web/core';

const ContentComponent = styled.div`
    flex-direction: column;
    min-width: 270px;
`;

interface DropDownMenuContentProps {
    children?: React.ReactNode;
    close?: $TSFixMeFunction;
}

const DropDownMenuContent = ({ close, children }: DropDownMenuContentProps) => (
    <ContentComponent data-test-action-dropdown>
        {/* @ts-expect-error $TSFixMeError: No overload matches this call. */}
        {Children.map(children, (c) => cloneElement(c, { close }))}
    </ContentComponent>
);

const Handle = (props: $TSFixMe) => {
    const { title, icon, component, expandIcon, primary, ...other } = props;

    return createElement(component, {
        title,
        icon,
        expandIcon,
        primary,
        ...other,
    });
};

const ActionDropdown = withToggleableOverlay({
    // @ts-expect-error $TSFixMeError: Type 'string' is not assignable to type 'never'.
    componentProps: ['children', 'close'],
    // @ts-expect-error $TSFixMeError: Type 'string' is not assignable to type 'never'.
    handleProps: ['title', 'icon', 'expandIcon', 'component', 'primary', 'disabled'],
    scrollAway: false,
})({
    HandleComponent: Handle,
    ContentComponent: DropDownMenuContent,
});

// @ts-expect-error $TSFixMeError: JSX element type 'ActionDropdown' does not have any construct or call signatures.
export default (props: $TSFixMe) => <ActionDropdown {...props} />;
